import { Layout, SchemaBreadcrumb, SEOHead } from "@/components";
import {
	DictionaryLinkCard,
	FerramentasHero,
	InfoSection,
	ToolsGrid,
} from "@/components/ferramentas";
import { FERRAMENTAS } from "@/constants/ferramentas";

const Ferramentas = () => {
	return (
		<Layout>
			<SEOHead
				title="Ferramentas para o Mercado Imobiliário | Portal CIB"
				description="Reunimos calculadoras, consultas oficiais, mapas cadastrais e recursos essenciais para corretores, cartórios e profissionais do mercado imobiliário."
				canonicalUrl="/ferramentas"
				keywords="ferramentas imobiliárias, calculadora imobiliária, consulta de imóveis, recursos para corretor, ferramentas para cartório, mapas cadastrais, CIB"
			/>
			<SchemaBreadcrumb />

			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
				<FerramentasHero />
				<DictionaryLinkCard />
				<ToolsGrid ferramentas={FERRAMENTAS} />
				<InfoSection />
			</div>
		</Layout>
	);
};

export default Ferramentas;
